<button
  [disabled]="disabled"
  mat-raised-button
  color="primary"
>
  <mat-icon
    style="
      display: flex;
      align-items: center;
      justify-content: center;
    "
    class="confirm-icon"
    svgIcon="{{EsvgFiles.correct}}"
  />
</button>
